/**
 * CU-v2 共通デザイントークン（JS/TS用）
 * アイコン色など、コンポーネント内で参照する場合に使用
 */
export const V2_TOKENS = {
    color: {
        primary: '#4b7fbf',
        text: '#1a1918',
        textSecondary: '#6d6c6a',
        textMuted: '#9c9b99',
        white: '#ffffff',
    },
} as const;
